{
  "version": 1,
  "asset_id": "35d2f570-17de-469c-8190-d158f34a20fa",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/35d2f570-17de-469c-8190-d158f34a20fa/thumb-violence.jpg",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/35d2f570-17de-469c-8190-d158f34a20fa/thumb-violence.jpg",
  "original_filename": "thumb-violence.jpg",
  "size": 111364,
  "content_type": "image/jpeg",
  "created_at": "2026-11-02T11:55:33Z"
}
